import { CategoryDownloadDto, ContentPostContentLocationDownloadDto, ContentPostContentTypeDownloadDto, ContentPostMediaTypeDownloadDto } from "collaboration-service";
import * as _ from "lodash";
import { BaseEditItem } from "./GeneralPostEdit";

export type GeneralPostEditAction =
    | { type: "batch", actions: GeneralPostEditAction[] }
    | { type: "setPost", post?: BaseEditItem }
    | { type: "setOriginalPost", post?: BaseEditItem }
    | { type: "setValue", nameStack: string[], value: any }
    | { type: "setCategories", categories?: CategoryDownloadDto[] }
    | { type: "setLocations", locations?: ContentPostContentLocationDownloadDto[] }
    | { type: "setContentTypes", contentTypes?: ContentPostContentTypeDownloadDto[] }
    | { type: "setMediaTypes", mediaTypes?: ContentPostMediaTypeDownloadDto[] }
    | { type: "addFile", nameStack: string[], lng?: string, selectMediaForLng?: string[] }
    | { type: "removeFile", nameStack: string[], lng?: string, selectMediaForLng?: string[] }
    | { type: "resetValue", nameStack: string[], lng?: string }
    ;
type A = GeneralPostEditAction;

export const GeneralPostEditActions = {
    batch: (actions: GeneralPostEditAction[]): A => ({ type: "batch", actions }),
    setPost: (post?: BaseEditItem): A => ({ type: "setPost", post }),
    setOriginalPost: (post?: BaseEditItem): A => ({ type: "setOriginalPost", post }),
    setValue: (nameStack: string[], value: any): A => ({ type: "setValue", nameStack, value }),
    setCategories: (categories?: CategoryDownloadDto[]): A => ({ type: "setCategories", categories }),
    setLocations: (locations?: ContentPostContentLocationDownloadDto[]): A => ({ type: "setLocations", locations }),
    setContentTypes: (contentTypes?: ContentPostContentTypeDownloadDto[]): A => ({ type: "setContentTypes", contentTypes }),
    setMediaTypes: (mediaTypes?: ContentPostMediaTypeDownloadDto[]): A => ({ type: "setMediaTypes", mediaTypes }),
    addFile: (nameStack: string[], lng?: string, selectMediaForLng?: string[]): A => ({ type: "addFile", nameStack, lng, selectMediaForLng }),
    removeFile: (nameStack: string[], lng?: string, selectMediaForLng?: string[]): A => ({ type: "removeFile", nameStack, lng, selectMediaForLng }),
    resetValue: (nameStack: string[]): A => ({ type: "resetValue", nameStack }),
};

export interface UploadList {
    nameStack: string[];
    lng?: string;
    selectMediaForLng?: string[];
}

export interface GeneralPostEditState {
    post?: BaseEditItem;
    originalPost?: BaseEditItem;
    categories?: CategoryDownloadDto[];
    locations?: ContentPostContentLocationDownloadDto[];
    contentTypes?: ContentPostContentTypeDownloadDto[];
    mediaTypes?: ContentPostMediaTypeDownloadDto[];
    files: UploadList[];
}

const initGeneralPostEditState = (): GeneralPostEditState => {
    return {
        files: [],
    };
}

export var getValGPE = (data: any, nameStack: string[]) => {
    let cur: any = data;
    for (let i = 0; i < nameStack.length; i++)
        cur = cur[nameStack[i]];
    return cur;
}
export var setValGPE = <T extends any>(data: T, nameStack: string[], value: any): { changed: boolean, data: T } => {
    // console.log('data => ', data);
    // console.log('nameStack => ', nameStack);
    // console.log('value => ', value);
    const p = _.clone(data);
    let cur: any = p;
    for (let i = 0; i < nameStack.length - 1; i++)
        cur = cur[nameStack[i]];
    const il = nameStack[nameStack.length - 1];
    // console.log('il => ', il);
    let val: any = value;
    if (typeof value === "function") {
        if (il)
            val = value(cur[il]);
        else
            val = value(cur);
    }
    // console.log('val => ', val);
    // console.log('cur => ', cur);
    // console.log('!_.isEqual(il ? cur[il] : cur, val) => ', !_.isEqual(il ? cur[il] : cur, val));
    if (!_.isEqual(il ? cur[il] : cur, val)) {
        if (il) {
            cur[il] = val;
            return { changed: true, data: p };
        }
        else
            return { changed: true, data: val };

    }
    return { changed: false, data }
}

export const generalPostEditReducer = (state: GeneralPostEditState = initGeneralPostEditState(), action: GeneralPostEditAction): GeneralPostEditState => {
    //console.log('action => ', action);
    switch (action.type) {
        case "batch":
            {
                let s = state;
                _.forEach(action.actions, a => {
                    s = generalPostEditReducer(s, a)
                });
                return s;
            }
        case "setPost":
            return { ...state, post: action.post };
        case "setOriginalPost":
            return { ...state, originalPost: action.post };
        case "setValue": {
            const c = setValGPE(state.post, action.nameStack, action.value);
            if (c.changed)
                return { ...state, post: c.data };
            break;
        }
        case "setCategories":
            if (!_.isEqual(state.categories, action.categories)) {
                return { ...state, categories: action.categories };
            }
            break;
        case "setLocations":
            if (!_.isEqual(state.locations, action.locations)) {
                return { ...state, locations: action.locations };
            }
            break;
        case "setContentTypes":
            if (!_.isEqual(state.contentTypes, action.contentTypes)) {
                return { ...state, contentTypes: action.contentTypes };
            }
            break;
        case "setMediaTypes":
            if (!_.isEqual(state.mediaTypes, action.mediaTypes)) {
                return { ...state, mediaTypes: action.mediaTypes };
            }
            break;
        case "addFile":
            if (_.find(state.files, nm => _.isEqual(nm.nameStack, action.nameStack) && nm.lng === action.lng && _.isEqual(nm.selectMediaForLng, action.selectMediaForLng)) === undefined) {
                return { ...state, files: [...state.files, { nameStack: action.nameStack, lng: action.lng, selectMediaForLng: action.selectMediaForLng }] };
            }
            break;
        case "removeFile": {
            const files = _.clone(state.files);
            const idx = _.findIndex(files, nm => _.isEqual(nm, action.nameStack) && nm.lng === action.lng && _.isEqual(nm.selectMediaForLng, action.selectMediaForLng));
            if (idx >= 0) {
                files.splice(idx, 1);
                return { ...state, files };
            }
            break;
        }
        case "resetValue": {
            const oV = getValGPE(state.originalPost, action.nameStack);
            const c = setValGPE(state.post, action.nameStack, oV);
            if (c.changed)
                return { ...state, post: c.data };
            break;
        }

    }
    return state;
};
